import React from 'react';
import styled from 'styled-components';

const StarIcon = styled.span.attrs({
    className: "material-symbols-rounded"
})`
    color: #FFF000;
    font-size: ${props => props.$isClickable ? '16px' : '13px'};
    cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
`;

const RatingContainer = styled.div`
    position: absolute;
    left: 8px;
    bottom: 8px;
    display: flex;
    align-items: center;
    gap: 0;
    padding: 4px;
    border-radius: 4px;
    cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
`;

const RatingText = styled.span.attrs({
    className: "bodytext-11"
})`
    color: #fff;
    line-height: 150%;
    margin-left: 2px;
    white-space: nowrap;
`;

const RatingStars = ({ rating, isClickable = false, onClick, showRatingText = false, ratingCount = 0 }) => {
    if (!rating || rating === 0) return null;

    const roundedRating = Math.round(rating * 2) / 2;
    const fullStars = Math.floor(roundedRating);
    const hasHalfStar = roundedRating % 1 !== 0;
    const showEmptyStars = !showRatingText;

    return (
        <RatingContainer $isClickable={isClickable} onClick={onClick}>
            {[...Array(fullStars)].map((_, i) => (
                <StarIcon key={`full-${i}`} $isClickable={isClickable}>star</StarIcon>
            ))}
            {hasHalfStar && <StarIcon $isClickable={isClickable}>star_half</StarIcon>}
            {showEmptyStars && [...Array(5 - Math.ceil(roundedRating))].map((_, i) => (
                <StarIcon key={`empty-${i}`} style={{ opacity: 0.0 }} $isClickable={isClickable}>star</StarIcon>
            ))}
            {showRatingText && (
                <RatingText>{rating.toFixed(2)}（{ratingCount}）</RatingText>
            )}
        </RatingContainer>
    );
};

export default RatingStars; 